import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaTrophy, FaAward, FaMedal, FaCode, FaGithub, FaCertificate, 
  FaStar, FaBriefcase, FaLightbulb, FaUsers
} from "react-icons/fa";
import GithubDaysCard from "./About/Github";
import LeetCodeCard from "./About/LeetCodeCard";
import GitRollCard from "./About/GitRollCard";

const individualAchievements = [
  {
    text: <>Selected for <b className="purple">Code for GovTech DMP'25</b> out of 55k+ registrations to build open‑source infra for Iabsis HCW DPG.</>,
    icon: <FaAward size={30} />,
    accentColor: "#8b5cf6", // Purple
  },
  {
    text: <>Selected for <b className="purple">Protocol Labs Dev Guild (PLDG) Cohort 2</b>, top 10% among global contributors building Web3 public impact projects.</>,
    icon: <FaTrophy size={30} />,
    accentColor: "#3b82f6", // Blue
  },
  {
    text: <>Recognized as a <b className="purple">Top-20 Mentor</b> in GirlScript Summer of Code-Extd (GSSoC'24 Extd) 2024.</>,
    icon: <FaUsers size={30} />,
    accentColor: "#ef4444", // Red
  },
  {
    text: <>Ranked <b className="purple">40th/27k+</b> Developers <span style={{ color: 'var(--text-secondary)' }}>(GirlScript Summer of Code)</span>.</>,
    icon: <FaMedal size={30} />,
    accentColor: "#10b981", // Emerald
  },
  {
    text: <>Ranked <b className="purple">10th/2k+</b> Developers <span style={{ color: 'var(--text-secondary)' }}>(Vinyasa Summer of Code)</span>.</>,
    icon: <FaMedal size={30} />,
    accentColor: "#f97316", // Orange
  },
  {
    text: <>Solved <b className="purple">1000+ DSA problems</b> across LeetCode, GFG, Codeforces, CodeChef, and CodeStudio.</>,
    icon: <FaCode size={30} />,
    accentColor: "#0ea5e9", // Sky Blue
  },
  {
    text: (
      <>
        <b className="purple">3300+ Github Contributions</b>:
        <ul style={{paddingLeft: '20px', marginTop: '8px', fontSize: '0.95em', listStylePosition: 'inside'}}>
          <li>180+ followers</li>
          <li>220+ merged PRs</li>
          <li>130+ day streak</li>
          <li>Part of 30+ top Open Source orgs</li>
        </ul>
      </>
    ),
    icon: <FaGithub size={30} />,
    accentColor: "#6366f1", // Indigo
  },
  {
    text: <>Top 5% <b className="purple">NPTEL Swayam</b> in: Internet of Things, Entrepreneurship, and Computer Networks & Internet Protocols.</>,
    icon: <FaCertificate size={30} />,
    accentColor: "#f59e0b", // Amber
  },
  {
    text: <>Certifications: Google Cybersecurity, Cloud Computing, Generative AI, Asia@Connect AI/ML, Postman API Expert.</>,
    icon: <FaLightbulb size={30} />,
    accentColor: "#ec4899", // Pink
  },
  {
    text: <>Open Source Certificates: Achievements from Timechainlabs, VSOC • 3× Appreciation from GirlScript, 1× SWoC.</>,
    icon: <FaStar size={30} />,
    accentColor: "#14b8a6", // Teal
  },
  {
    text: <>Secured a <b className="purple">paid internship</b> in 3rd semester through open‑source contributions.</>,
    icon: <FaBriefcase size={30} />,
    accentColor: "#22c55e", // Green
  },
];

function Stats({ currentTheme }) {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading" style={{ marginBottom: '2.5rem', textAlign: 'center', fontSize: '2.5em' }}>
          Achievements & <strong className="purple">Stats</strong>
        </h1>
        
        {/* Achievements Section */}
        <Row style={{ marginBottom: '3rem', justifyContent: 'center' }}>
          {individualAchievements.map((achievement, idx) => (
            <Col xs={12} md={6} lg={4} key={idx} className="achievement-card-col mb-4">
              <Card className="glass-card achievement-card h-100" style={{ borderTop: `5px solid ${achievement.accentColor}` }}>
                <Card.Body style={{ display: 'flex', flexDirection: 'column', padding: '1.5rem' }}>
                  <div style={{ color: achievement.accentColor, marginBottom: '1rem' }}>
                    {achievement.icon}
                  </div>
                  <Card.Text style={{ fontSize: '1.05em', lineHeight: '1.6' }}>
                    {achievement.text}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* GitHub Calendar - Original Placement */}
        <GithubDaysCard currentTheme={currentTheme} />
        
        {/* LeetCode and GitRoll Stats - Original Placement & Structure */}
        <Row style={{ justifyContent: "center", alignItems: "stretch", paddingBottom: "20px", paddingTop: "30px" }}>
          <Col md={6} className="d-flex justify-content-center align-items-stretch" style={{ paddingBottom: "30px" }}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
              <h2 className="project-heading" style={{ fontSize: "1.8em", paddingBottom: "15px", textAlign: "center" }}>
                My <strong className="purple">LeetCode</strong> Stats
              </h2>
              <LeetCodeCard username="Meetjain12" currentTheme={currentTheme} />
            </div>
          </Col>
          <Col md={6} className="d-flex justify-content-center align-items-stretch" style={{ paddingBottom: "30px" }}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
              <h2 className="project-heading" style={{ fontSize: "1.8em", paddingBottom: "15px", textAlign: "center" }}>
                My <strong className="purple">GitRoll</strong> Profile
              </h2>
              <GitRollCard username="Meetjain1" currentTheme={currentTheme} />
            </div>
          </Col>
        </Row>

        {/* GitHub Activity Images - Original Placement & Structure */}
        <h1 className="project-heading" style={{ paddingBottom: "20px", paddingTop: "30px", textAlign: 'center' }}>
            My <strong className="purple">GitHub</strong> Activity
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Col md={6} className="d-flex justify-content-center" style={{ paddingBottom: "30px" }}>
            <div className="stat-card">
              <a href="https://github.com/Meetjain1" target="_blank" rel="noopener noreferrer" style={{display: 'block', textAlign: 'center', width: '100%'}}>
                <img
                  src="https://github-readme-stats-plum-one-24.vercel.app/api?username=Meetjain1&show_icons=true&locale=en&theme=transparent&bg_color=00000000&hide_border=true&card_width=380&cache_seconds=1800"
                  alt="Meetjain1 GitHub Stats"
                  className="img-fluid"
                />
              </a>
            </div>
          </Col>
          <Col md={6} className="d-flex justify-content-center" style={{ paddingBottom: "30px" }}>
            <div className="stat-card">
              <a href="https://github.com/Meetjain1" target="_blank" rel="noopener noreferrer" style={{display: 'block', textAlign: 'center', width: '100%'}}>
                <img
                  src="https://github-readme-stats-plum-one-24.vercel.app/api/top-langs/?username=Meetjain1&show_icons=true&locale=en&layout=compact&theme=transparent&bg_color=00000000&hide_border=true&card_width=380&cache_seconds=1800"
                  alt="Meetjain1 Top Languages"
                  className="img-fluid"
                />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Stats; 
